import React from 'react';
import { Accordion, AccordionDetails, AccordionProps, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import styles from './SGSAccordion.module.scss';

export type OptionType = {
    value: string;
    label: string | JSX.Element;
};

type Props = AccordionProps & {
    summary?: JSX.Element;
};

const SGSAccordion: React.FC<Props> = ({ summary, children, ...props }) => {
    return (
        <Accordion {...props}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>{summary}</AccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    );
};

export default SGSAccordion;
